import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, AfterViewInit, Input, Output, HostListener } from '@angular/core';
import { DatePipe, formatDate, formatNumber } from '@angular/common';
import { concat, merge, of, from, forkJoin, Subject, Subscription, EMPTY } from 'rxjs';
import { map, switchMap, concatMap, debounceTime, distinctUntilChanged, startWith, takeUntil, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';

import { Person, PersonResponcibilityList } from 'src/app/shared/person';
import { Client, CustomerCategory } from 'src/app/shared/client';
import { ClientApiService } from 'src/app/services/client-api.service';
import { CliListEntry } from 'src/app/shared/cli-list-entry';
import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

@Component({
  selector: 'app-list-client-persons',
  templateUrl: './list-client-persons.component.html',
  styleUrls: ['./list-client-persons.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListClientPersonsComponent implements OnInit, OnDestroy, OnChanges {

  globalSettinsData: GlobalSettingsData;

  @Input() clientId: number;

  @ViewChild('personTable') personTable: Table;

  loading: boolean;
  rowIndex: number;
  editMode: boolean;
  totalRecords: number;
  rows: number = 10;

  fvPERSONLNAME: string;
  fvPERSONFNAME: string;
  fvPERSONMNAME: string;

  fvPERSONPHONE: string;
  fvPERSONFAX: string;
  fvPERSONCPHONE: string;
  fvPERSONPHONE1: string;
  fvPERSONFAX1: string;
  fvPERSONNOTE: string;
  fvPERSONNOTE1: string;
  fvPERSRESPONSIBLE: string;
  fvPERSONTITLE: string;
  fvPERSONCOUNTRY: string;
  fvPERSONCITY: string;
  fvPERSONADDR1: string;
  fvPERSONADDR2: string;
  fvPERSONEMAIL: string;
  fvPERSONINDEX: string;

  confirmDeleteOn: boolean = false;
  typeDeleteConfirmation: boolean = true;
  confirmText: string = 'DELETE THIS';
  deleteMessageText: string;

  personList: Person[];
  personCloneList: Person[] =[];

  selectedPerson: Person;

  /** Persons from the main organisation available for copying (null = not loaded yet). */
  mainOrgPersons: Person[] | null = null;
  mainOrgPersonsLoading: boolean = false;

  /** Display name of the found main organisation, shown in dialog header. */
  mainOrgName: string | null = null;

  /** Error/info message shown inside the dialog when main org cannot be found. */
  mainOrgError: string | null = null;

  /** Whether the "add from main org" dialog is open. */
  showFromMainOrgDialog: boolean = false;

  /** Persons selected in the multiselect list for copying. */
  selectedPersonsToCopy: Person[] = [];

  /** Whether a batch copy operation is in flight. */
  copyInProgress: boolean = false;

  private _getProdPartQuery: Subscription;
  private _personsQuery: Subscription;
  private _personEditQuery: Subscription;
  private _personDeleteQuery: Subscription;

  private destroy$ = new Subject<void>();
  private client$: Subject<number> = new Subject();

  private storeNameShowRowOptions: string = 'list-client-persons-columns-1';

  showPersRowsOptions = [
    { name: 'Примечания', value: 1 },
    { name: 'Телефон/Факс', value: 2 },
    { name: 'Адрес', value: 4 },
  ];

  showRowOptions: number[] = [];

  public get noItems(): boolean { return ((this.personList || []).length < 1); }

  public get seeNote(): boolean { return this.showRowOptions.includes(1); }
  public get seePhones(): boolean { return this.showRowOptions.includes(2); }
  public get seeAddress(): boolean { return this.showRowOptions.includes(4); }

  signPersonOptions = PersonResponcibilityList; /*[
    { name: 'Нема', value: 0 },
    { name: 'Може підписувати рахунки', value: 1 },
    { name: 'Повне право підпису (Директор)', value: 2 },
  ];*/

  public showPersonSignOption(o: number): string { return this.signPersonOptions.find(e => e.index == (o || 0)).value; }

  constructor(
    private cliApi: ClientApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    console.log('*** ListClientPersonsComponent in ngOnDestroy')

    localStorage.setItem(this.storeNameShowRowOptions, JSON.stringify(this.showRowOptions));

    if (this._personsQuery) { this._personsQuery.unsubscribe(); }

    if (this._personEditQuery) { this._personEditQuery.unsubscribe(); }

    if (this._personDeleteQuery) { this._personDeleteQuery.unsubscribe(); }

  }

  loadClientInformation() {
    this.client$.next(this.clientId);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** ListClientPersonsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];
      console.log('*** ListClientPersonsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'clientId':
          this.loadClientInformation();
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** ListClientPersonsComponent ngOnInit:');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    let _storedShowRowOptions: string = localStorage.getItem(this.storeNameShowRowOptions);
    if (_storedShowRowOptions) { this.showRowOptions = JSON.parse(_storedShowRowOptions); }

    this._personsQuery =
      this.client$.pipe(
        debounceTime(100),
//        distinctUntilChanged(),
        switchMap((cliId: number) => {
          console.log('*** ListClientPersonsComponent client$ subscribing....: ' + cliId)
          this.loading = true;

          return this.cliApi.getPersonsByClientId(cliId).pipe(map((pl: Person[]) => {
            this.personList = pl;
            this.totalRecords = this.personList.length
            from(pl).pipe(map((pr: Person) => (pr.cloneIndex = 0))).subscribe();
            this.loading = false;

          }));
        }),
        takeUntil(this.destroy$)
      )
        .subscribe();
    this.loadClientInformation();
}

  onRowSelect(event) {
    console.log('*** ListClientPersonsComponent onRowSelect: ' + JSON.stringify(event.data));
  }

  onRowUnselect(event) {
    console.log('*** ListClientPersonsComponent onRowUnselect: ' + JSON.stringify(event));
  }

  reloadDocContent(event) {
    console.log('*** ListClientPersonsComponent reloadDocContent: ' + JSON.stringify(event));

    this.loadClientInformation();
  }

  /**
   * Patches a single row into the already-loaded list without a server
   * round-trip -- e.g. `edit-client.component.ts` calls this after
   * `company-director-quick-set` (AG-23d) creates or updates the director
   * `Person` elsewhere on this same page, so this tab reflects it
   * immediately instead of showing stale data until the manager clicks
   * "Обновить" (`reloadDocContent`) or reopens the tab. Replaces the row
   * if `PERSID` is already present, otherwise appends it. Always assigns a
   * new array reference (never mutates `personList` in place), same
   * pattern `onAddRow` already uses, so the bound `p-table` picks it up.
   */
  upsertPerson(person: Person): void {
    console.log('*** ListClientPersonsComponent in upsertPerson: PERSID=' + person.PERSID);
    const index = (this.personList || []).findIndex(p => p.PERSID === person.PERSID);
    if (index >= 0) {
      this.personList = this.personList.map((p, i) => (i === index ? person : p));
    } else {
      this.personList = [...(this.personList || []), person];
      this.totalRecords = this.personList.length;
    }
  }

  onRowsOptionChange(event) {
    //  console.log('*** EditDocumentContentComponent in doChangeConditions: ' + JSON.stringify(event));
    //  console.log('*** EditDocumentContentComponent in doChangeConditions (showRowOptions): ' + JSON.stringify(this.showRowOptions));
  }

  onAddRow(event) {
    console.log('*** ListClientPersonsComponent in onAddRow: ' + JSON.stringify(event));

    this.personList = [...this.personList, {
      PERSID: -2,
      PERSCLIID: this.clientId,
      PERSONADDR1: null,
      PERSONADDR2: null,
      PERSONCITY: null,
      PERSONCOUNTRY: null,
      PERSONCPHONE: null,
      PERSONDEPT: null,
      PERSONEMAIL: null,
      PERSONFAX: null,
      PERSONFAX1: null,
      PERSONFNAME: null,
      PERSONIDCODE: null,
      PERSONINDEX: null,
      PERSONLNAME: null,
      PERSONMNAME: null,
      PERSONNOTE: null,
      PERSONNOTE1: null,
      PERSONPHONE: null,
      PERSONPHONE1: null,
      PERSONTITLE: null,
      PERSPASSWORD: null,
      PERSRESPONSIBLE: null,
      PERSSESSIONID: null,
      PERSSESSTIME: null,
      PERSSIGNID: null,
      cloneIndex: 0
    }];

    // environment.production || console.table(this.docItems);

    let ppe: Person = this.personList.find(e => e.PERSID == -2);
    this.onDiRowEditInit(ppe);
    this.personTable.initRowEdit(ppe);
  }

  onDiRowEditInit(esg: Person) {
    console.log('*** ListClientPersonsComponent in onPpRowEditInit: entry');
    //environment.production || console.table(esg);

    let newCloneIndex: number = 0;

    /*
     * Quite tricky algoritm:
     * Because we can edit simultaneously more than one row in the table.
     * Therefore for every edited row we have to create cloned copy in shadow array [securityGroupsClone]
     * We can't predict the order of starting and ending the edit process
     * 
     * So - Search for max cloneIndex in current table and assign +1 to newly created row copy
     *
     * When row either cancelled or saved - clone index resetted to 0, clone copy deleted from shadow array
     *
     */
    this.personList.forEach(pp => { newCloneIndex = Math.max(newCloneIndex, pp.cloneIndex) });

    console.log('*** ListClientPersonsComponent in onPpRowEditInit: newCloneIndex is: ' + newCloneIndex);

    esg.cloneIndex = ++newCloneIndex;
    this.personCloneList.push({ ...esg });

    this.editMode = true;
  }

  onExtendedEdit(esg: Person) {
    console.log('*** ListClientPersonsComponent in onExtendedEdit: ' + JSON.stringify(esg) );
  }

  onDiRowEditCancel(esg: Person, index: number) {
    console.log('*** ListClientPersonsComponent in onPpRowEditCancel: ' + index);
    //environment.production || console.table(esg);

    let ppid = this.personCloneList.findIndex(sg => sg.cloneIndex == esg.cloneIndex);

    if (esg.PERSID == -2) {
      // Cancel the newly created record
      // simply delete

      this.personList.splice(index, 1);

    } else {
      // Cancel editing of existing record
      // have to reload it from database

      this.personList[index] = { ...this.personCloneList[ppid] };
      this.personList[index].cloneIndex = 0;
    }

    this.personCloneList.splice(ppid, 1);

    this.editMode = false;
  }

  onDiRowEditSave(esg: Person) {
    console.log('*** ListClientPersonsComponent in onRowEditSave: ');
    environment.production || console.table(esg);

    let ppid = this.personCloneList.findIndex(sg => sg.cloneIndex == esg.cloneIndex);

    this._personEditQuery =
      concat(
        // postPersonById still emits the full Person entity (Observable<Person>) while
        // putPersonById emits a row count (Observable<number>, Prompt 13-F interim rule) --
        // the intermediate map(p => p.PERSID) unifies both ternary branches to
        // Observable<number> so the outer .pipe()/.subscribe() below type-checks.
        ((esg.PERSID == -2) ? this.cliApi.postPersonById(esg).pipe(map(p => p.PERSID)) : this.cliApi.putPersonById(esg))
        .pipe(map((count) => {
          console.log('*** ListClientPersonsComponent in onSubscribe to Save: ' + count);

          this.personCloneList.splice(ppid, 1);
          esg.cloneIndex = 0;
          this.reloadDocContent(null);
          this.editMode = false;
        })),
      )
        .subscribe();
  }

  onRemoveAllRow(event) {
    console.log('*** ListClientPersonsComponent in onRemoveAllRow: ' + JSON.stringify(event));

    if (!(this.editMode || this.noItems)) {
  //  this.confirmText = 'DELETE ';
  //  this.typeDeleteConfirmation = true;
  //  this.confirmDeleteOn = true;
    }
  }

  onDeleteConfirmation(event) {
    console.log('*** ListClientPersonsComponent onDeleteConfirmation: ' + JSON.stringify(event));
    
    if (event) {
      console.log('*** ListClientPersonsComponent DO DELETE!!! NOW!!!');

      this._personDeleteQuery =
        this.cliApi.deletePersonById(this.selectedPerson)
        .pipe(map(data => {
          this.confirmDeleteOn = false;
          this.reloadDocContent(null);
        }))
          .subscribe();
    }
  }

  onRemoveRow(event) {
    console.log('*** ListClientPersonsComponent in onRemoveRow: ' + JSON.stringify(event));

    if (!this.editMode && this.selectedPerson) {
      this.confirmText = 'DELETE ' + this.selectedPerson.PERSID;
      this.deleteMessageText = 'Вы собираетесь удалить контакт: ' + this.selectedPerson.PERSONLNAME + '. Уверены?';

      this.typeDeleteConfirmation = true;
      this.confirmDeleteOn = true;
    }

  }

  onAddFromMainOrgClick(event: any): void {
    this.showFromMainOrgDialog = true;
    this.selectedPersonsToCopy = [];
    this.mainOrgPersons = null;
    this.mainOrgName = null;
    this.mainOrgError = null;

    if (!this.clientId) { return; }
    this.mainOrgPersonsLoading = true;

    // CUSTOMERCATEGORY is never populated by the API — it is enriched client-side.
    // Resolve the group name via getCustomerCategoryByID(CASTCATID) explicitly.
    this.cliApi.getClientById(this.clientId).pipe(
      switchMap((clients: Client[]) => {
        const current = clients?.[0];
        if (!current?.CASTCATID) {
          this.mainOrgError = 'Компания не входит ни в одну группу компаний.';
          this.mainOrgPersonsLoading = false;
          return EMPTY;
        }
        return forkJoin({
          category: this.cliApi.getCustomerCategoryByID(current.CASTCATID),
          group: this.cliApi.getClientChildren(this.clientId)
        }).pipe(
          map(({ category, group }) => ({
            currentNickname: current.CLIENTSNIKNAME,
            catName: (category as CustomerCategory[])?.[0]?.CASTCATNAME,
            group
          }))
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: ({ currentNickname, catName, group }: { currentNickname: string, catName: string, group: CliListEntry[] }) => {
        if (!catName) {
          this.mainOrgError = 'Компания не входит ни в одну группу компаний.';
          this.mainOrgPersonsLoading = false;
          return;
        }

        if (currentNickname === catName) {
          this.mainOrgError = 'Текущая компания является основной организацией группы.';
          this.mainOrgPersonsLoading = false;
          return;
        }

        const mainOrg = group.find(c => c.CLIENTSNIKNAME === catName);

        if (!mainOrg) {
          this.mainOrgError = 'Основная организация не найдена в группе компаний.';
          this.mainOrgPersonsLoading = false;
          return;
        }

        this.mainOrgName = mainOrg.CLIENTSNIKNAME;

        this.cliApi.getPersonsByClientId(mainOrg.CLIID)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (mainPersons: Person[]) => {
              const existingKeys = new Set(
                (this.personList || []).map(
                  p => (p.PERSONLNAME || '').trim() + '|' + (p.PERSONFNAME || '').trim()
                )
              );
              this.mainOrgPersons = mainPersons.filter(
                p => p.PERSRESPONSIBLE !== -1 &&
                     !existingKeys.has(
                       (p.PERSONLNAME || '').trim() + '|' + (p.PERSONFNAME || '').trim()
                     )
              );
              this.mainOrgPersonsLoading = false;
            },
            error: () => {
              this.mainOrgError = 'Ошибка загрузки сотрудников основной организации.';
              this.mainOrgPersonsLoading = false;
            }
          });
      },
      error: () => {
        this.mainOrgError = 'Ошибка загрузки данных компании.';
        this.mainOrgPersonsLoading = false;
      }
    });
  }

  onConfirmCopyFromMainOrg(): void {
    if (!this.selectedPersonsToCopy.length || this.copyInProgress) { return; }
    this.copyInProgress = true;

    from(this.selectedPersonsToCopy).pipe(
      concatMap(p => {
        const copy: Person = {
          ...p,
          PERSID: -2,                   // new-record sentinel (backend uses MAX+1)
          PERSCLIID: this.clientId,     // target child company
          PERSONDEPT: null,
          PERSSIGNID: null,             // signature is company-specific — do not copy
          PERSPASSWORD: null,
          PERSSESSIONID: null,
          PERSSESSTIME: null,
          cloneIndex: 0
        };
        return this.cliApi.postPersonById(copy).pipe(
          catchError(() => EMPTY)       // skip errors; service handleError shows alert
        );
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      complete: () => {
        this.copyInProgress = false;
        this.showFromMainOrgDialog = false;
        this.selectedPersonsToCopy = [];
        this.loadClientInformation();   // reload the persons table
      }
    });
  }

  onCancelFromMainOrgDialog(): void {
    this.showFromMainOrgDialog = false;
    this.selectedPersonsToCopy = [];
  }

}


/*

SELECT [PERSID]
      ,[PERSCLIID]
      ,[PERSONDEPT]
      ,[PERSONIDCODE]
      ,[PERSONFNAME]
      ,[PERSONMNAME]
      ,[PERSONLNAME]
      ,[PERSONPHONE]
      ,[PERSONFAX]
      ,[PERSONCPHONE]
      ,[PERSONPHONE1]
      ,[PERSONFAX1]
      ,[PERSONNOTE]
      ,[PERSONNOTE1]
      ,[PERSONTITLE]
      ,[PERSONCOUNTRY]
      ,[PERSONCITY]
      ,[PERSONADDR1]
      ,[PERSONADDR2]
      ,[PERSONEMAIL]
      ,[PERSONINDEX]
      ,[PERSPASSWORD]
      ,[PERSSESSIONID]
      ,[PERSSESSTIME]
      ,[PERSRESPONSIBLE]
      ,[PERSSIGNID]
  FROM [dbo].[Person]

 */ 
